import { Email } from "@faire/web--source/slate/icons/foundation/Email";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { ContactUsOptionsWrapper } from "./ContactUsOptionsWrapper";
import { IconWrapper } from "./IconWrapper";

interface IProps {
  to: string;
  onClick?: () => void;
}

export const EmailUs: React.FC<IProps> = ({ to, onClick }) => {
  const history = useHistory();
  const handleClick = () => {
    onClick?.();
    history.push(to);
  };

  return (
    <ContactUsOptionsWrapper onClick={handleClick} dataTestId="email-us-btn">
      <ColumnWrapper>
        <IconWrapper>
          <Email fontSize="24" />
        </IconWrapper>
        <Spacer height="1x" />
        <Spacer height="1/2x" />
        <LeftMarginWrapper>
          <Typography variant="paragraphSansMedium">
            <StrictLocalMsg
              defaultMessage="Email"
              description={{
                text: "Title of the email us button",
                img: "https://cdn.faire.com/fastly/3e5042128a8728530ffecf6ba6eac69e1a5a49069a1441af7c25d0d1851ed8a5.png",
              }}
            />
          </Typography>
          <Spacer height="1x" />
          <Typography variant="paragraphSansRegular">
            <StrictLocalMsg
              defaultMessage="Average reply: 24 hours"
              description={{
                text: "describe the average reply time for email us",
                img: "https://cdn.faire.com/fastly/3e5042128a8728530ffecf6ba6eac69e1a5a49069a1441af7c25d0d1851ed8a5.png",
              }}
            />
          </Typography>
        </LeftMarginWrapper>
      </ColumnWrapper>
    </ContactUsOptionsWrapper>
  );
};

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  ${responsiveMediaQueries.tabletAndBelow} {
    flex-direction: row;
    min-width: 250px;
    align-items: center;
  }
`;

export const LeftMarginWrapper = styled(Column).attrs({ justify: "center" })<{
  width?: string;
}>`
  margin-left: ${getSpacing("1/2x")};
  ${responsiveMediaQueries.tabletAndBelow} {
    margin-left: ${getSpacing("2x")};
  }
  width: ${({ width }) => width ?? "auto"};
`;
